import { Panel, Kpi } from "@/components/common";
import { EquityCurve } from "@/components/EquityCurve";
import { usePoll } from "@/hooks/usePoll";
import { gbp, fmt, pnlClass, ldnTime } from "@/lib/api";

export function OilDemo() {
  const { data: p } = usePoll("/oil/performance", 15000);
  if (!p) return null;
  const pct = (v) => (v == null ? "-" : `${fmt(v)}%`);
  return (
    <Panel title="Demo account" testid="oil-demo-panel"
      right={<span className="text-xs text-slate-500" data-testid="oil-demo-since">{p.first_trade ? `Since ${ldnTime(p.first_trade)}` : "No closed trades yet"}{p.live_sizing ? " · sizing from MT5 while live" : ""}</span>}>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-6">
        <Kpi label="Balance" value={gbp(p.balance)} sub={`Start ${gbp(p.starting_balance)}`} testid="oil-demo-balance" />
        <Kpi label="Equity" value={gbp(p.equity)} sub={`Open ${gbp(p.open_pnl)}`} testid="oil-demo-equity" />
        <Kpi label="Total profit" value={<span className={pnlClass(p.total_pnl)}>{gbp(p.total_pnl)}</span>} sub={pct(p.return_pct)} testid="oil-demo-total" />
        <Kpi label="Today" value={<span className={pnlClass(p.today_pnl)}>{gbp(p.today_pnl)}</span>} testid="oil-demo-today" />
        <Kpi label="Win rate" value={pct(p.win_rate)} sub={`${p.wins} won, ${p.losses} lost${p.trades - p.wins - p.losses ? `, ${p.trades - p.wins - p.losses} flat` : ""}`} testid="oil-demo-winrate" />
        <Kpi label="Trades" value={p.trades} sub={p.avg_points != null ? `Avg ${fmt(p.avg_points)} pts` : undefined} testid="oil-demo-trades" />
        <Kpi label="Average win" value={gbp(p.avg_win)} testid="oil-demo-avg-win" />
        <Kpi label="Average loss" value={gbp(p.avg_loss)} testid="oil-demo-avg-loss" />
        <Kpi label="Profit factor" value={p.profit_factor != null ? fmt(p.profit_factor) : "-"} testid="oil-demo-pf" />
        <Kpi label="Best trade" value={gbp(p.best)} testid="oil-demo-best" />
        <Kpi label="Worst trade" value={gbp(p.worst)} testid="oil-demo-worst" />
        <Kpi label="Max drawdown" value={gbp(p.max_drawdown)} sub={pct(p.max_drawdown_pct)} testid="oil-demo-drawdown" />
      </div>
      <div className="mt-5"><EquityCurve points={p.curve} title="Demo account equity" testid="oil-demo-curve" /></div>
    </Panel>
  );
}
